var scope_0 = require('/Users/antonio-escritorio/Documents/moare/sites-estaticos/libres-de-violencias/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5d1151d7e26d49cfc92f6cbf75673969.js').default;
var scope_1 = require('/Users/antonio-escritorio/Documents/moare/sites-estaticos/libres-de-violencias/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5eecb6303f945beaef11e078cfcdc93c.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    